/*! jQuery Lazy - Media Breakpoints
* Prefined classes to match boostrap media breakpoints for jquery lazy 
* Example: .lazy-sm-up or .lazy-md-down */

(function ( $ ) {
 
    $.Lazy.media_breakpoints = function( options ) {
    		
    		// Default options
        var settings = $.extend({
            breakpoints: {
            	'sm' : 576,
            	'md' : 768,
            	'lg' : 992,
            	'xl' : 1200
            }
        }, options );

        // Create media breakpoint classes
				setMediaBreakpoints = function() {
					if(settings.breakpoints) {
						 $.each(settings.breakpoints, function(index, value) {
						 	 if($(window).width() <= value) {
						 	 	 $(".lazy-" + index + "-down").not('.lazy-initialized').Lazy().addClass("lazy-initialized");
						 	 }
						 	 if($(window).width() >= value) {
						 	 	 $(".lazy-" + index + "-up").not('.lazy-initialized').Lazy().addClass("lazy-initialized");
						 	 }
						 });
					}
				}

				// Init
        setMediaBreakpoints();

        // Reset on window resize
				$(window).resize(function() {
					setMediaBreakpoints();
				});
 
    };
 
}( jQuery ));


//////////////////
// WEBPACK FOOTER
// ./assets/js/vendors/jquery-lazy-mb.js
// module id = 108
// module chunks = 0